import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";
import TextInput from "../../../lib/TextInput";
import OMath from "../../utils/OMath";

export default class OTextInput extends TextInput {
    constructor(text, style, canvas = null) {
        super(style);

        this.json = style;
        this._onKillEvent = "kill_event";
        this._onReviveEvent = "revive_event";
        this._onDestroyEvent = "destroy_event";

        this.on("keydown", this._onKeyDownUpdate, this);
        this.on("keyup", this._onKeyUpUpdate, this);
        this.on("input", this._onInputUpdate, this);
        this.on("focus", this._onFocusUpdate, this);
        this.on("blur", this._onBlurUpdate, this);
        this._onKeydownEvent = "keydownupdate";
        this._onKeyupEvent = "keyupupdate";
        this._onInputEvent = "inputupdate";
        this._onFocusEvent = "focusupdate";
        this._onBlurEvent = "blurupdate";

        this._saveVisible = true;
        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this._isUpdate = false;
        this.aa_isRegOnDebug = false;
        this._inDebug = false;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;

        this._toUpperCase = style.hasOwnProperty("toUpperCase") ? style["toUpperCase"] : false;

        this._oType = OmyConst.OMY_TEXT_FONT_INPUT;

        this._textValue = text;
        this._fontEx = "px";
        this._fontSize = Number(style.input.fontSize.split(this._fontEx)[0]);

        this._align = style.align || "left";
        this._alignV = style.alignV || "top";
        this.align = this._align;
        this.alignV = this._alignV;
        if (style.hasOwnProperty("maxLength") && style.maxLength > 0)
            this.maxLength = style.maxLength;
        if (style.hasOwnProperty("placeholder"))
            this.placeholder = style.placeholder;
        if (style.hasOwnProperty("restrict"))
            this.restrict = style.restrict;
        if (style.hasOwnProperty("substituteText"))
            this.substituteText = style.substituteText;
        this.text = this._textValue;

        this._checkFontSize = style["checkFontSize"] || false;
        if (this._checkFontSize)
            this.addInput(this._checkScale, this);
        this._defaultFontSize = this._fontSize;
        this._sizeCoef = style["sizeCoef"] || 1.35;
        this._maxWidth = style["checkLength"] || this.maxLength;
    }

    /**     * @private     */
    _updateDebug() {
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
    }

    drawDebugRect() {
    }

    /**     * @public     */
    removeDrawDebugRect() {
    }

    setInputStyle(key, value) {
        super.setInputStyle(key, value);
    }

    blur() {
        super.blur();
    }

    select() {
        super.select();
    }

    focus() {
        super.focus();
    }

    /** @type {string | Array.<string> | number | Array.<number> | CanvasGradient | CanvasPattern} */
    setColor(tColor) {
        this.setInputStyle("color", tColor);
    }

    /**     * @public     */
    kill() {
        if (this._active) {
            this._active = false;
            if (this._isUpdate)
                Omy.removeUpdater(this.update, this);
            if (this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = false;
                Omy.removeUpdater(this._updateDebug, this);
            }
            this._saveVisible = this.visible;
            this.visible = false;
            this.renderable = false;
            this.emit(this._onKillEvent, this);
        }

        return this;
    }

    /**     * @public     */
    revive() {
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (this._isUpdate)
                Omy.addUpdater(this.update, this);
            if (Omy.debugMode && !this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = true;
                Omy.addUpdater(this._updateDebug, this);
            }

            this.visible = this._saveVisible;
            this.emit(this._onReviveEvent, this);
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        options = options || { children: true, texture: false, baseTexture: false };
        this.json = null;
        this._active = false;
        this.userData = null;
        this._textValue = null;
        this._eventData = null;
        this.isUpdate = false;
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }

        this.emit(this._onDestroyEvent, this);
        this.removeAllListeners(this._onDestroyEvent);
        this.removeAllListeners(this._onKillEvent);
        this.removeAllListeners(this._onReviveEvent);
        this.removeAllListeners(this._onKeydownEvent);
        this.removeAllListeners(this._onKeyupEvent);
        this.removeAllListeners(this._onInputEvent);
        this.removeAllListeners(this._onFocusEvent);
        this.removeAllListeners(this._onBlurEvent);
        this.removeAllListeners("keydown");
        this.removeAllListeners("keyup");
        this.removeAllListeners("input");
        this.removeAllListeners("focus");
        this.removeAllListeners("blur");

        this.renderable = false;
        this.visible = false;

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update() {
    }

    setXY(ax, ay) {
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchor.set(ax, ay);
    }

    setPivot(ax, ay) {
        this.pivot.set(ax, ay);
    }

    addKill(func, context, once) {
        this._addNewEvent(this._onKillEvent, func, context, once);
    }

    addRevive(func, context, once) {
        this._addNewEvent(this._onReviveEvent, func, context, once);
    }

    addDestroy(func, context, once) {
        this._addNewEvent(this._onDestroyEvent, func, context, once);
    }

    addKeyDown(func, context, once) {
        this._addNewEvent(this._onKeydownEvent, func, context, once);
    }

    addKeyUp(func, context, once) {
        this._addNewEvent(this._onKeyupEvent, func, context, once);
    }

    addInput(func, context, once) {
        this._addNewEvent(this._onInputEvent, func, context, once);
    }

    addFocus(func, context, once) {
        this._addNewEvent(this._onFocusEvent, func, context, once);
    }

    addBlur(func, context, once) {
        this._addNewEvent(this._onBlurEvent, func, context, once);
    }

    /**     * @private     */
    _addNewEvent(event, func, context, once = false) {
        if (once)
            this.once(event, func, context);
        else
            this.on(event, func, context);
    }

    removeKill(func, context) {
        this.removeListener(this._onKillEvent, func, context);
    }

    removeRevive(func, context) {
        this.removeListener(this._onReviveEvent, func, context);
    }

    removeDestroy(func, context) {
        this.removeListener(this._onDestroyEvent, func, context);
    }

    removeKeyDown(func, context, once) {
        this.removeListener(this._onKeydownEvent, func, context);
    }

    removeKeyUp(func, context, once) {
        this.removeListener(this._onKeyupEvent, func, context);
    }

    removeInput(func, context, once) {
        this.removeListener(this._onInputEvent, func, context);
    }

    removeFocus(func, context, once) {
        this.removeListener(this._onFocusEvent, func, context);
    }

    removeBlur(func, context, once) {
        this.removeListener(this._onBlurEvent, func, context);
    }

    removeUp() {

    }

    removeDragUpdate() {

    }

    /**     * @private     */
    _onKeyDownUpdate(keycode) {
        this.emit(this._onKeydownEvent, this, keycode);
    }

    /**     * @private     */
    _onKeyUpUpdate(keycode) {
        this.emit(this._onKeyupEvent, this, keycode);
    }

    /**     * @private     */
    _onInputUpdate(text) {
        this.emit(this._onInputEvent, this, text);
    }

    /**     * @private     */
    _onFocusUpdate() {
        this.emit(this._onFocusEvent, this);
    }

    /**     * @private     */
    _onBlurUpdate() {
        this.emit(this._onBlurEvent, this);
    }

    _checkScale() {
        this.setInputStyle("fontSize", String(this._defaultFontSize) + this._fontEx);
        if (this._maxWidth < this.text.length) {
            let fontSize = OMath.int(this._fontSize - (this.text.length - this._maxWidth) * this._sizeCoef);
            this.setInputStyle("fontSize", String(fontSize) + this._fontEx);
        }
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------
    get align() {
        return this._align;
    }

    set align(value) {
        this._align = value;
        this.setInputStyle("text-align", value);
    }

    get alignV() {
        return this._alignV;
    }

    set alignV(value) {
        this._alignV = value;
        this.setInputStyle("vertical-align", value);

    }

    set isUpdate(value) {
        if (!this._isUpdate && value) {
            Omy.addUpdater(this.update, this);
        } else if (this._isUpdate && !value) {
            Omy.removeUpdater(this.update, this);
        }
        this._isUpdate = value;
    }

    get isUpdate() {
        return this._isUpdate;
    }

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this.pivot.x;
    }

    set pivotX(value) {
        this.pivot.x = value;
    }

    get pivotY() {
        return this.pivot.y;
    }

    set pivotY(value) {
        this.pivot.y = value;
    }

    get anchorX() {
        return this.anchor.x;
    }

    set anchorX(value) {
        this.anchor.x = value;
    }

    get anchorY() {
        return this.anchor.y;
    }

    set anchorY(value) {
        this.anchor.y = value;
    }

    get globalLeft() {
        return this.getGlobalPosition().x;
    }

    get globalTop() {
        return this.getGlobalPosition().y;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    set text(value) {
        this._textValue = value;
        super.text = (this._toUpperCase) ? this._textValue.toUpperCase() : this._textValue;
        if (this.json && this._checkFontSize) Omy.game.addNextTickUpdate(this._checkScale, this);
    }

    get text() {
        return super.text;
    }

    set fontSize(value) {
        if (String(value).split(this._fontEx).length > 1) value = Number(String(value).split(this._fontEx)[0]);
        this._fontSize = value;
        this.setInputStyle("fontSize", String(this._fontSize) + this._fontEx);
    }

    get fontSize() {
        return this._fontSize;
    }

    get oType() {
        return this._oType;
    }

    get disabled() {
        return super.disabled;
    }

    set disabled(value) {
        super.disabled = value;
    }

    get htmlInput() {
        return super.htmlInput;
    }

    get restrict() {
        return super.restrict;
    }

    set restrict(value) {
        super.restrict = value;
    }

    get maxLength() {
        return super.maxLength;
    }

    set maxLength(value) {
        super.maxLength = value;
    }

    get placeholder() {
        return super.placeholder;
    }

    set placeholder(value) {
        super.placeholder = value;
    }
}
